import { render, staticRenderFns } from "./expense_voucher.vue?vue&type=template&id=10820f23&"
import script from "./expense_voucher.vue?vue&type=script&lang=js&"
export * from "./expense_voucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports